import { z } from 'zod'

import { viewPageSchema } from './viewPage.ts'

// 会話記録（transcript.jsonl）の1行。形は salescore-agent-docs の全体設計書の arch/codex/data-formats/storage-files.md の「transcript.jsonl」にある。
// storage は type と id を持つ行だけを返し、ほかの項目はランナーが書いたまま返すので、知らない項目も取り除かずに残す
export const transcriptRecordSchema = z.looseObject({
  // message、event、revision のいずれか
  type: z.string(),
  // ターンの中で一意な ID。再配信でも変わらないので、受け取る側はこれで重複を除く
  id: z.string(),
})

// 指示と回答の message レコード。storage の getTurns の messages に入る
export const messageRecordSchema = z.looseObject({
  type: z.literal('message'),
  id: z.string(),
  role: z.enum(['user', 'assistant']),
  content: z.string(),
  // runtime が user のメッセージに残す添付ファイルのパス。添付がなければない
  attachments: z.array(z.string()).optional(),
  // runtime が user のメッセージに残す会話の対象の view。対象がなければない
  page: viewPageSchema.optional(),
})

// ターンの終わりの turn.completed レコード。storage の getTurns の completion に入る
export const turnCompletedRecordSchema = z.looseObject({
  type: z.literal('event'),
  id: z.string(),
  event: z.literal('turn.completed'),
  status: z.enum(['completed', 'interrupted', 'failed']),
  // 失敗したときの理由。失敗でなければ null
  error: z.string().nullable(),
})

// ターンを巻き戻した turn.reverted レコード。storage の getTurns の reversion に入る。
// 初回のリリースでは runtime が書かないので、storage が確かめる event のほかは決めない
export const turnRevertedRecordSchema = z.looseObject({
  type: z.literal('event'),
  id: z.string(),
  event: z.literal('turn.reverted'),
})
